import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  withStyles,
  Grid,
  DialogActions,
  Dialog,
  Button,
  DialogContent,
  DialogTitle,
  TextField,
  FormHelperText,
  TableCell,
  Tooltip,
  // Paper
} from '@material-ui/core';

import { Delete } from '@material-ui/icons';
import { withTranslation } from 'react-i18next';
import MUIDataTable from 'mui-datatables';
import Swal from 'sweetalert2';
import { clearLocalStorage } from '../../utils/common';
import resetpasswordIcon from '../../images/Presense/Icon/resetpassword.svg';
import './styles/dialog.css';
import './styles/devicesview.css';

const errRequired = 'required_field';
const errPassword = 'passwords_dont_match';
const errPasswordLength = 'password_length';

class CreateAccount extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        username: '',
        password: '',
        confirmPassword: '',
        patientId: null,
      },
      errorField: {
        password: {
          flag: false,
          msg: '',
        },
        confirmPassword: {
          flag: false,
          msg: '',
        },
        username: false,
        // confirmPassword: false,
        comparePassword: false,
      },
      isDisplayForm: false,
      isCreate: false,
    };
  }

  handleSubmit = async (patient) => {
    const { data } = this.state;
    const { t } = this.props;
    data.patientId = patient.id;
    data.tenantId = patient.tenantId;
    const valid = this.validate();

    if (valid) {
      try {
        const res = await this.props.user.createUserPatient(data);
        if (res.statusCode === 200) {
          Swal.fire({
            type: 'success',
            html: `<h4>${t('create_success')}`,
            showConfirmButton: false,
            timer: 500,
            customClass: {
              container: 'my-swal',
            },
          }).then(async () => await this.props.user.getUserPatient(patient.id));
          this.onBack();
        }
      } catch (err) {
        if (err.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        } else if (err.statusCode === 400) {
          Swal.fire({
            type: 'error',
            html: `<h4>${err.error.message}`,
            customClass: {
              container: 'my-swal',
            },
          });
        }
      }
    }
  };

  onTextChange = (e) => {
    const { name, value } = e.target;
    this.clearErrorField(name);
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
    });
  };

  clearErrorField(key) {
    if (key === 'username') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          username: false,
        },
      });
    }
    if (key === 'password') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          //   password: false,
          password: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'confirmPassword') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          confirmPassword: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'comparePassword') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          comparePassword: false,
        },
      });
    }
  }

  validate() {
    const { data } = this.state;

    let checkUsername = !data.username ? true : false;
    let checkPassword = { flag: false, msg: '' };
    let checkConfirmPassword = { flag: false, msg: '' };

    checkPassword = !data.password ? { flag: true, msg: errRequired } : this.validatePasswordLength(data.password);
    checkConfirmPassword = this.validatePassword(data.password, data.confirmPassword);

    this.setState({
      errorField: {
        username: checkUsername,
        password: checkPassword,
        confirmPassword: checkConfirmPassword,
      },
    });
    return !(checkUsername || checkPassword.flag || checkConfirmPassword.flag);
  }

  validatePasswordLength(password) {
    if (password.length < 6) {
      return { flag: true, msg: errPasswordLength };
    }
    return { flag: false, msg: '' };
  }

  validatePassword(password, confirmPassword) {
    if (!confirmPassword) {
      return { flag: true, msg: errRequired };
    } else {
      if (confirmPassword.length < 6) {
        return { flag: true, msg: errPasswordLength };
      } else {
        if (password && password !== confirmPassword) {
          return { flag: true, msg: errPassword };
        }
      }
    }
    return { flag: false, msg: '' };
  }

  getFullname = (language, data) => {
    let fullname = '';
    if (language && language === 'th-TH') {
      if (data.firstname || data.lastname) {
        fullname = `${data.firstname ?? ''} ${data.lastname ?? ''}`;
      } else {
        fullname = `${data.firstnameEn ?? ''} ${data.lastnameEn ?? ''}`;
      }
    }

    if (language && language === 'en-EN') {
      if (data.firstnameEn || data.lastnameEn) {
        fullname = `${data.firstnameEn ?? ''} ${data.lastnameEn ?? ''}`;
      } else {
        fullname = `${data.firstname ?? ''} ${data.lastname ?? ''}`;
      }
    }

    return fullname;
  };

  confirmErrorText = () => {
    const { t } = this.props;
    const { confirmPassword, comparePassword } = this.state.errorField;
    if (confirmPassword && !comparePassword) {
      return t('required_field');
    }
    if (confirmPassword && comparePassword) {
      return t('password is not correct');
    }
  };

  onResetPassword = async () => {
    const { data } = this.state;
    const { t } = this.props;
    const valid = this.validate();

    if (valid) {
      try {
        const res = await this.props.user.resetPassword(data);
        if (res.statusCode === 200) {
          Swal.fire({
            type: 'success',
            html: `<h4>${t('update_success')}`,
            showConfirmButton: false,
            timer: 500,
            customClass: {
              container: 'my-swal',
            },
          }).then(() => this.onBack());
        }
      } catch (err) {
        if (err.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        } else if (err.statusCode === 400) {
          Swal.fire({
            type: 'error',
            html: `<h4>${err.error.message}`,
            customClass: {
              container: 'my-swal',
            },
          });
        }
      }
    }
  };

  onDeleteAccount = (users, patientId) => {
    const { t } = this.props;
    Swal.fire({
      html: `<h4>${t('remove_user_from_list')}`,
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: `${t('cancel')}`,
      confirmButtonText: `${t('remove')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const userId = users && users[0];
          const result = await this.props.user.deleteUserPatient(userId);
          if (result.statusCode === 200) {
            Swal.fire({
              html: `<h4>${t('remove_success')}`,
              type: 'success',
              showConfirmButton: false,
              timer: 500,
            }).then(async () => await this.props.user.getUserPatient(patientId));
          } else {
            Swal.fire({
              html: `<h4>${t('failed_to_remove')}`,
              type: 'error',
              showConfirmButton: false,
              timer: 1000,
            });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({
              html: `<h4>${t('failed_to_remove')}`,
              type: 'error',
              showConfirmButton: false,
              timer: 1000,
            });
          }
        }
      }
    });
  };

  onDisplayFormCreateAccount = () => {
    this.setState({ isDisplayForm: true, isCreate: true });
  };

  onDisplayFormChangePassword = (users) => {
    if (users.length > 0) {
      this.setState({
        isDisplayForm: true,
        data: {
          username: users[1],
        },
      });
    }
  };

  onBack = () => {
    this.setState({
      isDisplayForm: false,
      isCreate: false,
      data: {
        username: '',
        password: '',
        confirmPassword: '',
        patientId: null,
      },
      errorField: {
        password: {
          flag: false,
          msg: '',
        },
        confirmPassword: {
          flag: false,
          msg: '',
        },
        username: false,
        // comparePassword: false,
      },
    });
  };

  render() {
    let { props, state, t, patientData, classes } = this.props;
    const patient = props.data ? props.data.patient : patientData;
    const { data, isDisplayForm, isCreate } = this.state;
    const { usersPatient } = this.props.user.toJS();
    const fullname = this.getFullname(localStorage.getItem('i18nextLng'), patient);

    const columns = [
      {
        name: 'id',
        label: 'ID',
        options: {
          display: false,
        },
      },
      {
        name: 'userName',
        label: `${t('username')}`,
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: 'options',
        label: `${t('options')}`,
        options: {
          filter: false,
          customHeadRender: (columnMeta, updateDirection) => (
            <TableCell key={2} align='center'>
              {t('options')}
            </TableCell>
          ),
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return (
              <div className={this.props.classes.columnWidth200}>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Tooltip title={t('changePassword')} classes={{ tooltip: classes.tooltip }}>
                    <img
                      src={resetpasswordIcon}
                      alt='changePassword'
                      id='changePassword'
                      width='24'
                      className={classes.marginRightIcon}
                      onClick={() => this.onDisplayFormChangePassword(row)}
                    />
                  </Tooltip>
                  <Tooltip title={t('delete')} classes={{ tooltip: classes.tooltip }}>
                    <Delete
                      color='primary'
                      style={{ cursor: 'pointer' }}
                      onClick={() => this.onDeleteAccount(row, patient.id)}
                      id='delete'
                    />
                  </Tooltip>
                </div>
              </div>
            );
          },
        },
      },
    ];

    return (
      <Dialog
        open={state.dialogCreateAccount.open}
        onClose={this.props.handleClose}
        aria-labelledby='form-dialog-title'
        maxWidth='sm'
        fullWidth
        PaperProps={{
          style: {
            overflowY: 'hidden',
            borderRadius: 8,
          },
        }}
      >
        <DialogTitle className='header' id='form-dialog-title'>
          {/* {t("manage_myactsense_account_for")}{" "}
          <span className="headerMain">{fullname}</span> */}
          <Grid container style={{ position: 'relative' }}>
            <div>
              {t('manage_myactsense_account_for')} <span className='headerMain'>{fullname}</span>
            </div>
            <div className='closeIcon' onClick={this.props.handleClose}>
              <svg width='32' height='32' viewBox='0 0 32 32'>
                <use xlinkHref={`/images/menus-v1.svg#close`} />
              </svg>
            </div>
          </Grid>
        </DialogTitle>
        <DialogContent style={{ maxHeight: '315px' }}>
          <Grid container item>
            {!isDisplayForm && (
              <Button
                variant='contained'
                size='small'
                color='primary'
                onClick={this.onDisplayFormCreateAccount}
                id='createaccount'
              >
                {t('create_account')}
              </Button>
            )}
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'center', marginTop: 15 }}>
            {isDisplayForm ? (
              <div>
                <div className={props.classes.formInput}>
                  <TextField
                    error={!data.username ? this.state.errorField.username : false}
                    id='txtUsername'
                    name='username'
                    label={t('username')}
                    value={(data && data.username) || ''}
                    onChange={(e) => this.onTextChange(e)}
                    type='text'
                    fullWidth
                    disabled={isCreate ? false : true}
                  />
                  <FormHelperText
                    error
                    hidden={!data.username ? !this.state.errorField.username : true}
                    id='component-error-text'
                  >
                    {t('required_field')}
                  </FormHelperText>
                </div>

                <div className={props.classes.formInput}>
                  <TextField
                    error={!data.password ? this.state.errorField.password.flag : false}
                    id='txtPassword'
                    name='password'
                    label={isCreate ? t('password') : t('newPassword')}
                    value={(data && data.password) || ''}
                    onChange={(e) => this.onTextChange(e)}
                    type='password'
                    fullWidth
                    inputProps={{
                      autoComplete: 'new-password',
                    }}
                  />
                  <FormHelperText error hidden={!this.state.errorField.password.flag} id='component-error-text'>
                    {t(`${this.state.errorField.password.msg}`)}
                  </FormHelperText>
                </div>

                <div className={props.classes.formInput}>
                  <TextField
                    error={!data.confirmPassword ? this.state.errorField.confirmPassword.flag : false}
                    id='txtConfirmPassword'
                    name='confirmPassword'
                    label={t('confirm_password')}
                    value={(data && data.confirmPassword) || ''}
                    onChange={(e) => this.onTextChange(e)}
                    type='password'
                    fullWidth
                  />
                  <FormHelperText error hidden={!this.state.errorField.confirmPassword.flag} id='component-error-text'>
                    {t(`${this.state.errorField.confirmPassword.msg}`)}
                  </FormHelperText>
                </div>

                <Grid container justify='center' alignItems='center' spacing={8}>
                  <Grid item>
                    <Button onClick={this.onBack} color='primary' variant='outlined' id='back'>
                      {t('back')}
                    </Button>
                  </Grid>
                  <Grid item>
                    {isCreate ? (
                      <Button
                        onClick={() => this.handleSubmit(patient)}
                        color='primary'
                        id='createaccount'
                        variant='contained'
                      >
                        {t('create')}
                      </Button>
                    ) : (
                      <Button
                        onClick={() => this.onResetPassword()}
                        color='primary'
                        id='changePassword'
                        variant='contained'
                      >
                        {t('changePassword')}
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </div>
            ) : (
              <div>
                <MUIDataTable
                  data={usersPatient}
                  columns={columns}
                  searchable={false}
                  options={{
                    viewColumns: false,
                    filter: false,
                    sort: false,
                    download: false,
                    print: false,
                    pagination: false,
                    selectableRowsOnClick: false,
                    selectableRows: 'none',
                    searchable: false,
                    search: false,
                    responsive: 'scrollFullHeight',
                    rowsPerPage: 5,
                  }}
                />
              </div>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          {/* {!isDisplayForm && (
            <Button onClick={this.props.handleClose} color="default" id="close">
              {t("close")}
            </Button>
          )} */}
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme) => ({
  chip: {
    fontSize: '0.9rem',
    fontWeight: '600',
    color: '#fff',
  },
  marginRightIcon: {
    marginRight: 10,
    cursor: 'pointer',
  },
  tooltip: {
    fontSize: '16px',
  },
});

export const page = inject('dashboard', 'patient', 'device', 'user')(observer(CreateAccount));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
